import React, { useState, type FC, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import api from '../services/api';
import LoadingView from '../components/LoadingView';

const DeviceUsers: FC = () => {
    const [anonymizedIds, setAnonymizedIds] = useState<string[]>([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedId, setSelectedId] = useState('');
    const [chartUrls, setChartUrls] = useState<string[]>([]);

    const updateData = async () => {
        setLoading(true);
        const { ids, success } = await api.getAnonymizedDeviceUsers();
        if (success) {
            setAnonymizedIds(ids);
            setErrorMessage('');
        } else {
            setAnonymizedIds([]);
            setErrorMessage('Failed to load data');
        }

        setLoading(false);
    };

    useEffect(() => {
        void updateData();
    }, []);

    const fetchCharts = async (id: string) => {
        setLoading(true);
        const { charts, success } = await api.getAnonymizedDeviceUserCharts(id);
        if (success) {
            setChartUrls(charts);
            setErrorMessage('');
        } else {
            setChartUrls([]);
            setErrorMessage('Failed to load data');
        }

        setLoading(false);
    };

    useEffect(() => {
        if (selectedId) {
            void fetchCharts(selectedId);
        }
    }, [selectedId]);

    return (
        <>
            <div className="text-primary text-3xl pb-4">Reports</div>
            {loading && <LoadingView />}
            {!loading && (
                <>
                    {anonymizedIds.length > 0 && (
                        <Dropdown
                            value={selectedId}
                            options={anonymizedIds}
                            placeholder="Select User"
                            className="max-w-full mb-4"
                            onChange={(event) => {
                                setSelectedId(event.value as string);
                            }}
                        />
                    )}
                    {errorMessage && (
                        <div className="text-primary text-xl mb-4">
                            Error: {errorMessage}
                        </div>
                    )}
                    {chartUrls.map((url) => (
                        <img
                            key={url}
                            className="w-[1125px] max-w-full mb-4"
                            crossOrigin="anonymous"
                            src={`${url}&html=false`}
                        />
                    ))}
                </>
            )}
        </>
    );
};

export default DeviceUsers;
